<app-header [isMainMenuVisible]="false"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
